import { basename as D } from "path";
import { a, t as y, c as P } from "./chunks/index-5de47637.mjs";
import "toastify-js";
import q from "vue";
import { D as x } from "./chunks/DialogBase-708412c6.mjs";
import B from "@mdi/svg/svg/folder-multiple.svg?raw";
import T from "@mdi/svg/svg/folder-move.svg?raw";
const k = (d, l, n = () => {
}) => {
  const u = document.createElement("div");
  (document.querySelector(l == null ? void 0 : l.container) || document.body).appendChild(u);
  const h = new q({ el: u, name: "VueDialogHelper", render: (s) => s(d, { props: l, on: { close: () => {
    n(), h.$destroy();
  } } }) });
};
async function V(d, l, n = !1, u, h, s = a.Choose, M, r) {
  const b = (t, c) => {
    const i = (e) => {
      const p = (e == null ? void 0 : e.root) || "";
      let o = (e == null ? void 0 : e.path) || "";
      return o.startsWith(p) && (o = o.slice(p.length) || "/"), o;
    };
    return n ? (e) => t(e.map(i), c) : (e) => t(i(e[0]), c);
  }, w = (t) => {
    var c, i, e, p, o, m;
    return { id: t.fileid || null, path: t.path, mimetype: t.mime || null, mtime: ((c = t.mtime) == null ? void 0 : c.getTime()) || null, permissions: t.permissions, name: ((i = t.attributes) == null ? void 0 : i.displayname) || t.basename, etag: ((e = t.attributes) == null ? void 0 : e.etag) || null, hasPreview: ((p = t.attributes) == null ? void 0 : p.hasPreview) || null, mountType: ((o = t.attributes) == null ? void 0 : o.mountType) || null, quotaAvailableBytes: ((m = t.attributes) == null ? void 0 : m.quotaAvailableBytes) || null, icon: null, sharePermissions: null };
  };
  let v;
  s === a.Custom ? (v = [], (r.buttons || []).forEach((t) => {
    v.push({ callback: b(l, t.type), label: t.text, type: t.defaultButton ? "primary" : "secondary" });
  })) : v = (t, c) => {
    var i, e, p;
    const o = [], m = ((e = (i = t == null ? void 0 : t[0]) == null ? void 0 : i.attributes) == null ? void 0 : e.displayName) || ((p = t == null ? void 0 : t[0]) == null ? void 0 : p.basename), f = m || D(c);
    return s === a.Choose && o.push({ callback: b(l, a.Choose), label: m && !n ? y("Choose {file}", { file: m }) : y("Choose"), type: "primary" }), (s === a.CopyMove || s === a.Copy) && o.push({ callback: b(l, a.Copy), label: f ? y("Copy to {target}", { target: f }) : y("Copy"), type: "primary", icon: B }), (s === a.Move || s === a.CopyMove) && o.push({ callback: b(l, a.Move), label: f ? y("Move to {target}", { target: f }) : y("Move"), type: s === a.Move ? "primary" : "secondary", icon: T }), o;
  };
  const C = {};
  typeof (r == null ? void 0 : r.filter) == "function" && (C.filterFn = (t) => r.filter(w(t)));
  const g = typeof u == "string" ? [u] : u || [];
  k(P, { ...C, name: d, buttons: v, multiselect: n, path: M, mimetypeFilter: g, allowPickDirectory: (r == null ? void 0 : r.allowDirectoryChooser) === !0 || g.includes("httpd/unix-directory") });
}
async function W(d, l, n, u) {
  k(x, { name: l, message: d, buttons: [{ label: "No", callback: () => n(!1) }, { label: "Yes", type: "primary", callback: () => n(!0) }], size: "small" }, () => n(!1));
}
export {
  W as confirm,
  V as filepicker
};
